<template>
  <div class="aiagent_wrap">
    <div class="left-box">
      <!-- 固定顶栏：显示当前选中菜单（点击右侧菜单后同步更新） -->
      <div class="page-head">
        <div class="tip-block"></div>
        <span class="page-head-root">数智员工</span>
        <span class="page-head-sep">&gt;</span>
        <span class="page-head-cur">{{ currentTabName }}</span>
        <!-- 分布式节点状态：固定展示在顶栏右上角 -->
        <div v-if="tabId === 12 && canWrite" class="head_nodes">
          <span class="nodes_title">分布式节点</span>
          <el-tag size="mini" :type="onlineNodeCount ? 'success' : 'info'">
            {{ onlineNodeCount }} / {{ teamNodes.length }} 在线
          </el-tag>
          <el-tooltip v-if="teamNodes.length" effect="dark" placement="bottom-end">
            <div slot="content">
              <div v-for="n in teamNodes" :key="n.node_id">
                {{ n.name || n.node_id }} · {{ n.url }} · {{ n.status === 'active' ? '在线' : '离线' }}
              </div>
            </div>
            <span class="nodes_detail">{{ nodeSummary }}</span>
          </el-tooltip>
          <span v-else class="nodes_detail" title="分布式成员将按成员地址直连，无地址或无健康节点时自动本地执行">
            暂无已注册节点
          </span>
          <el-button type="text" size="mini" :loading="nodeLoading" @click="loadNodeStatus">刷新节点</el-button>
        </div>
      </div>
      <div :class="['page-body', { cards_mode: [0, 4, 6, 8, 12].includes(tabId) }]">
        <!-- 数字员工 / 协作团队 子 Tab：选中样式与费用管理-订单管理 Tab 一致 -->
        <div v-show="tabId === 0 || tabId === 12" class="staff_head">
          <div class="staff_tabs">
            <span :class="{ active: tabId === 0 }" @click="switchTab(0)">数字员工</span>
            <span :class="{ active: tabId === 12 }" @click="switchTab(12)">协作团队</span>
          </div>
          <!-- 数字员工查询栏与新增按钮：与 Tab 同行，右侧对齐 -->
          <div v-if="tabId === 0" class="staff_query">
            <el-form :inline="true" :model="agentQuery" size="small" class="query_form">
              <el-form-item label="名称">
                <el-input v-model="agentQuery.name" placeholder="名称模糊搜索" clearable
                          style="width: 140px" @keyup.enter.native="onAgentSearch" />
              </el-form-item>
              <el-form-item label="状态">
                <el-select v-model="agentQuery.status" placeholder="全部" clearable style="width: 100px">
                  <el-option label="启用" value="active" />
                  <el-option label="已归档" value="archived" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="onAgentSearch">查询</el-button>
                <el-button size="small" @click="onAgentReset">重置</el-button>
              </el-form-item>
            </el-form>
            <el-button v-if="canWrite" type="primary" icon="el-icon-plus" size="small"
                       @click="onAgentAdd">新增数字员工</el-button>
          </div>
          <!-- 协作团队查询栏与新增按钮：同样与 Tab 同行，右侧对齐 -->
          <div v-else-if="tabId === 12" class="staff_query">
            <el-form :inline="true" :model="teamQuery" size="small" class="query_form">
              <el-form-item label="名称">
                <el-input v-model="teamQuery.name" placeholder="名称模糊搜索" clearable
                          style="width: 140px" @keyup.enter.native="onTeamSearch" />
              </el-form-item>
              <el-form-item label="队长">
                <el-select v-model="teamQuery.leader_agent_id" placeholder="全部" clearable filterable
                           style="width: 140px">
                  <el-option v-for="a in teamLeadOptions" :key="a.agent_id"
                             :label="a.display_name || a.name" :value="a.agent_id" />
                </el-select>
              </el-form-item>
              <el-form-item label="状态">
                <el-select v-model="teamQuery.status" placeholder="全部" clearable style="width: 100px">
                  <el-option label="生效" value="active" />
                  <el-option label="归档" value="archived" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="onTeamSearch">查询</el-button>
                <el-button size="small" @click="onTeamReset">重置</el-button>
              </el-form-item>
            </el-form>
            <el-button v-if="canWrite" type="primary" icon="el-icon-plus" size="small"
                       @click="onTeamAdd">新增团队</el-button>
          </div>
        </div>
        <!-- 各期在此追加组件，v-show="tabId === N" -->
        <agents v-show="tabId === 0" ref="agents" @view-sessions="onViewSessions" />
        <!-- 协作团队：队长 + 成员分工；队长发起对话自动进入团队编排（含分布式成员转发） -->
        <teams v-show="tabId === 12" ref="teams" @open-chat="onOpenTeamChat"
               @team-members="onTeamMembers" @agents-loaded="onTeamAgentsLoaded" />
        <sessions v-show="tabId === 1" ref="sessions" @switch-tab="switchTab" />
        <chat v-show="tabId === 2" ref="chat"
              @agents-change="onChatAgents" @agent-change="onChatAgentChange" />
        <knowledge v-show="tabId === 3" ref="knowledge" />
        <skills v-show="tabId === 4" ref="skills" />
        <models v-show="tabId === 5" ref="models" />
        <tools-tab v-show="tabId === 6" ref="tools" />
        <scheduled v-show="tabId === 7" ref="scheduled" />
        <memory v-show="tabId === 8" ref="memory" @switch-tab="switchTab" />
        <!-- P6 通用技能：依赖后端沙箱（status 探测失败/未开启时 Tab 整体隐藏） -->
        <general-skills v-show="tabId === 9" ref="gs" />
        <!-- P7 员工商店：管理员(3)维护模板，企业(2)目录+使用模板，个人(1)不可见 -->
        <agent-templates v-show="tabId === 10" ref="tpl" />
      </div>
    </div>

    <!-- 右侧菜单：由原顶部横向标签改为竖向面板；外层铺满留白，内层 sticky 固定 -->
    <div class="right-box">
      <div class="right-box-container">
        <!-- 技能 / 工具 / 记忆：横排快捷入口，选中项蓝色背景 -->
        <div v-if="quickTabs.length" class="right-quick-row">
          <div v-for="t in quickTabs" :key="t.id"
               :class="['right-quick-item', { active: tabId === t.id }]"
               @click="switchTab(t.id)">{{ t.name }}</div>
        </div>

        <div v-for="t in mainTabs" :key="t.id" class="right-item" @click="switchTab(t.id)">
          <!-- 协作团队属于数字员工模块：切换团队时右侧「数字员工」保持选中 -->
          <div :class="(t.id === 0 ? (tabId === 0 || tabId === 12) : tabId === t.id) ? 'right-item-select' : 'right-item-unselect'"></div>
          <div class="right-item-title">
            <span>
              <i v-if="t.icon" :class="t.icon" class="right-item-icon"></i>{{ t.name }}
            </span>
          </div>
        </div>

        <!-- 对话功能：数字员工以列表形式列在右侧功能列下方，点击即切换当前对话对象 -->
        <div v-if="tabId === 2" class="right-agent-box">
          <div class="right-agent-head">数字员工</div>
          <div v-if="chatAgents.length" class="right-agent-list">
            <div v-for="a in chatAgents" :key="a.id"
                 :class="['right-agent-item', { active: a.id === chatAgentId }]"
                 :title="a.name" @click="pickAgent(a.id)">
              <i class="el-icon-user-solid right-agent-icon"></i>
              <span class="right-agent-name">{{ a.name }}</span>
            </div>
          </div>
          <div v-else class="right-agent-empty">暂无可用数字员工</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Agents from './agents/index.vue'
import Teams from './teams/index.vue'
import Sessions from './sessions/index.vue'
import Chat from './chat/index.vue'
import Knowledge from './knowledge/index.vue'
import Skills from './skills/index.vue'
import Models from './models/index.vue'
import ToolsTab from './tools/index.vue'
import Scheduled from './scheduled/index.vue'
import Memory from './memory/index.vue'
import GeneralSkills from './generalSkills/index.vue'
import AgentTemplates from './agentTemplates/index.vue'
import { agentBody, isEnterprise } from './utils'

// Tab 可见性按 acctype 控制：1 个人 / 2 企业 / 3 平台
const TABS = [
  { id: 0, name: '数字员工', roles: ['1', '2'] },
  { id: 1, name: '会话管理', roles: ['1', '2'] },
  { id: 2, name: '对话', roles: ['1', '2'] },
  { id: 3, name: '知识库', roles: ['1', '2'] },
  // skills 个人也可管理自己的技能（owner 由服务端判定）
  { id: 4, name: '技能', roles: ['1', '2'] },
  // tools 个人只读浏览（写入口在组件内按 acctype 收敛）；平台管理员同页管理平台资源
  { id: 6, name: '工具', roles: ['1', '2', '3'] },
  // 定时任务写操作仅企业（个人/平台不可见）；记忆个人只读（删除按钮组件内收敛）
  { id: 7, name: '定时任务', roles: ['2'] },
  { id: 8, name: '记忆', roles: ['1', '2'] },
  // 通用技能写操作走真实沙箱；后端 sandbox.enabled=false 时能力不可用，Tab 由 status 探测动态显隐
  { id: 9, name: '通用技能', roles: ['1', '2'] },
  // 底部功能区：模型配置（齿轮）与员工商店（商店），models 写操作仅企业，个人隐藏
  { id: 5, name: '模型配置', roles: ['2'] },
  // 员工商店：管理员(3)维护模板，企业(2)目录+使用模板创建；个人(1)不可见
  { id: 10, name: '员工商店', roles: ['2', '3'] }
]
// 右侧横排快捷项：技能 / 工具 / 记忆
const QUICK_TAB_IDS = [4, 6, 8]
export default {
  name: 'AiAgent',
  components: { Agents, Teams, Sessions, Chat, Knowledge, Skills, Models, ToolsTab, Scheduled, Memory, GeneralSkills, AgentTemplates },
  data() {
    return {
      tabId: 0,
      acctype: localStorage.getItem('acctype') || '',
      gsEnabled: false,
      // 对话页右侧员工列表与当前选中项（由 chat 子组件上抛同步）
      chatAgents: [],
      chatAgentId: '',
      // 数字员工查询条件（查询栏已上移到子 Tab 同行）
      agentQuery: { name: '', status: '' },
      // 协作团队查询条件与队长下拉（员工列表由 teams 加载后回传）
      teamQuery: { name: '', leader_agent_id: '', status: '' },
      teamLeadOptions: [],
      // 分布式节点注册表（展示在顶栏右上角）
      teamNodes: [],
      nodeLoading: false
    }
  },
  computed: {
    canWrite() {
      return isEnterprise()
    },
    onlineNodeCount() {
      return this.teamNodes.filter(n => n.status === 'active').length
    },
    nodeSummary() {
      return this.teamNodes.map(n => `${n.name || n.node_id} · ${n.status === 'active' ? '在线' : '离线'}`).join('、')
    },
    visibleTabs() {
      // 通用技能 Tab 额外受沙箱开关控制；后端未发 status 接口（404）或未开启均隐藏，无破坏
      const t = TABS.filter(x => x.roles.includes(this.acctype) && (x.id !== 9 || this.gsEnabled))
      // 个人视图"数字员工"实为只读"我的数字员工"，名称在子组件内按 acctype 区分
      return t.length ? t : []
    },
    // 顶栏与右侧菜单选中项同名：点击右侧菜单即刷新顶栏
    // 协作团队不再出现在右侧菜单，仅保留顶部子 Tab，名称单独兜底
    currentTabName() {
      const t = this.visibleTabs.find(x => x.id === this.tabId)
      if (t) return t.name
      return this.tabId === 12 ? '协作团队' : ''
    },
    // 技能 / 工具 / 记忆 单独提为上方横排，其余保持竖向列表
    quickTabs() {
      return this.visibleTabs.filter(t => QUICK_TAB_IDS.includes(t.id))
    },
    mainTabs() {
      return this.visibleTabs.filter(t => !QUICK_TAB_IDS.includes(t.id))
    }
  },
  mounted() {
    this.probeGs()
  },
  beforeDestroy() {
    // 清掉未触发的探测重试，防离开页面后仍发请求
    clearTimeout(this._gsRetryTimer)
  },
  methods: {
    // 探测通用技能沙箱能力（仅个人/企业账号需要）；网络失败一次性兜底重试，
    // 业务成功但未开启不重试（后端中途开启沙箱需刷新页面，属可接受低频场景）
    probeGs(retry) {
      if (!['1', '2'].includes(this.acctype)) return
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentGenSkillsStatus, agentBody({})).then((res) => {
        if (res.data.code == 0 && res.data.data && res.data.data.sandbox_enabled) this.gsEnabled = true
      }).catch(() => {
        if (!retry) this._gsRetryTimer = setTimeout(() => this.probeGs(true), 5000)
      })
    },
    switchTab(id) {
      this.tabId = id
    },
    // 分布式节点注册表：顶栏右上角在线状态（心跳过期按离线展示）
    loadNodeStatus() {
      this.nodeLoading = true
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentTeamsNodesList, agentBody({})).then((res) => {
        if (res.data.code == 0) this.teamNodes = res.data.data || []
        this.nodeLoading = false
      }).catch(() => { this.nodeLoading = false })
    },
    // 数字员工查询/重置/新增：查询栏在父级，实际动作委托给 agents 子组件
    onAgentSearch() {
      if (this.$refs.agents) this.$refs.agents.applyQuery(this.agentQuery)
    },
    onAgentReset() {
      this.agentQuery = { name: '', status: '' }
      if (this.$refs.agents) this.$refs.agents.resetQuery()
    },
    onAgentAdd() {
      if (this.$refs.agents) this.$refs.agents.openAdd()
    },
    // 协作团队查询/重置/新增：同样委托给 teams 子组件
    onTeamSearch() {
      if (this.$refs.teams) this.$refs.teams.applyQuery(this.teamQuery)
    },
    onTeamReset() {
      this.teamQuery = { name: '', leader_agent_id: '', status: '' }
      if (this.$refs.teams) this.$refs.teams.resetQuery()
    },
    onTeamAdd() {
      if (this.$refs.teams) this.$refs.teams.openAdd()
    },
    onTeamAgentsLoaded(list) {
      this.teamLeadOptions = list || []
    },
    // 接收对话子组件的可用员工列表与选中项
    onChatAgents(list) {
      this.chatAgents = list || []
    },
    onChatAgentChange(id) {
      this.chatAgentId = id || ''
    },
    // 右侧列表点选员工：交给 chat 统一切换（含会话清空与列表加载）
    pickAgent(id) {
      if (this.$refs.chat) this.$refs.chat.selectAgent(id)
      this.chatAgentId = id || ''
    },
    // agents「查看会话」→ 切会话 Tab 并按 agent 过滤（v-show 常驻已挂载，nextTick 保险）
    onViewSessions(agentId) {
      this.tabId = 1
      this.$nextTick(() => this.$refs.sessions.filterByAgent(agentId))
    },
    // 团队「去对话」→ 切对话 Tab 并选中队长员工（团队编排由队长回合自动触发）
    onOpenTeamChat(leaderAgentId) {
      this.tabId = 2
      this.$nextTick(() => {
        if (this.$refs.chat) this.$refs.chat.selectAgent(leaderAgentId)
      })
    },
    // 团队「团队成员」→ 切数字员工 Tab 并按该团队队长+成员集合过滤展示
    onTeamMembers(payload) {
      this.tabId = 0
      // 团队筛选优先于名称/状态，父级查询栏同步清空避免条件不一致
      this.agentQuery = { name: '', status: '' }
      this.$nextTick(() => {
        if (this.$refs.agents) this.$refs.agents.filterByTeamMembers(payload)
      })
    }
  },
  watch: {
    tabId(val) {
      this.$forceUpdate() // 切 Tab 时子组件按需自刷新（各期子组件自行 watch 激活）
      // 团队 Tab 激活时刷新员工下拉与列表
      if (val === 12 && this.$refs.teams) this.$refs.teams.onActivate()
      // 团队 Tab 激活时同步刷新顶栏分布式节点状态
      if (val === 12 && this.canWrite) this.loadNodeStatus()
      // 会话 Tab 激活时刷新下拉，防 agents Tab 增删后数据过期
      if (val === 1 && this.$refs.sessions) this.$refs.sessions.loadAgents()
      // 对话 Tab 激活时同样刷新，保证 agent 下拉与新建/删除同步
      if (val === 2 && this.$refs.chat) this.$refs.chat.onActivate()
      // 知识库 Tab 激活时刷新，保证库/文档数据最新
      if (val === 3 && this.$refs.knowledge) this.$refs.knowledge.onActivate()
      // 技能/模型配置 Tab 激活时刷新（组件内 onActivate 首次才拉取）
      if (val === 4 && this.$refs.skills) this.$refs.skills.onActivate()
      if (val === 5 && this.$refs.models) this.$refs.models.onActivate()
      if (val === 6 && this.$refs.tools) this.$refs.tools.onActivate()
      if (val === 7 && this.$refs.scheduled) this.$refs.scheduled.onActivate()
      if (val === 8 && this.$refs.memory) this.$refs.memory.onActivate()
      if (val === 9 && this.$refs.gs) this.$refs.gs.onActivate()
      if (val === 10 && this.$refs.tpl) this.$refs.tpl.onActivate()
    }
  }
}
</script>

<style lang="less" scoped>
.aiagent_wrap {
  display: flex;
  align-items: stretch;
  // 直接按视口高度锁定（index_content 顶部固定 70px），保证底部分页贴在浏览器底部
  height: calc(100vh - 70px);
  min-height: calc(100vh - 70px);
  background: #F2F2F2;
}

.left-box {
  flex: 1;
  min-width: 0;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-right: 5px;
}

// 顶部固定栏：sticky 相对页面滚动容器（index/index.css 的 .section overflow:auto）
.page-head {
  flex: 0 0 70px;
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  height: 70px;
  padding-left: 10px;
  background-color: #fff;
  box-sizing: border-box;
}

.tip-block {
  width: 10px;
  height: 10px;
  background: #8C7EBB;
  margin-right: 15px;
  flex: 0 0 auto;
}

.page-head-root {
  font-size: 16px;
  color: #606266;
}

.page-head-sep {
  margin: 0 8px;
  color: #C0C4CC;
}

.page-head-cur {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

// 顶栏右上角：分布式节点状态
.head_nodes {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  padding-right: 4px;
  .nodes_title {
    font-size: 13px;
    color: #606266;
  }
  .nodes_detail {
    max-width: 420px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: #909399;
  }
}

.page-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 1px 0px 0px;
  box-sizing: border-box;
  // 卡片列表页：仅卡片区内部滚动，外层不滚动
  &.cards_mode {
    overflow: hidden;
  }
  // 非卡片列表页保持自然高度，由 page-body 统一滚动
  > * {
    flex: 0 0 auto;
    min-height: 0;
  }
  // 数字员工 / 协作团队：仅卡片区内部滚动，顶部查询与底部分页固定
  > .agents_wrap,
  > .skills_wrap,
  > .tools_wrap,
  > .mem_wrap,
  > .teams_wrap {
    flex: 1 1 auto;
  }
}

// 数字员工 / 协作团队 子 Tab：选中样式与「费用管理-订单管理」Tab 一致（1px #12618A 下划线）
.staff_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  padding: 0px 12px 0px 0px;
  margin-bottom: 10px;
  background: #fff;
  border-bottom: 1px solid #e4e7ed;
  box-sizing: border-box;
}
.staff_tabs {
  display: flex;
  height: 100%;
  span {
    height: 100%;
    line-height: 40px;
    padding: 0 20px;
    text-align: center;
    display: inline-block;
    box-sizing: border-box;
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    background: transparent;
    cursor: pointer;
    border-bottom: 1px solid transparent;
    &.active {
      background: transparent;
      border-bottom-color: #12618A;
    }
  }
}
.staff_query {
  display: flex;
  align-items: center;
  gap: 10px;
  .query_form {
    /deep/ .el-form-item {
      margin: 0 10px 0 0;
    }
    /deep/ .el-form-item:last-child {
      margin-right: 0;
    }
    /deep/ .el-form-item__label {
      line-height: 32px;
    }
  }
  .el-button + .el-button {
    margin-left: 8px;
  }
}

.right-box {
  flex: 0 0 240px;
  width: 240px;
  background-color: #fff;
}

// 外层不固定高度（白底铺满整列），内层 sticky 与顶栏同一滚动容器，一起钉住
.right-box-container {
  position: sticky;
  top: 0;
}

.right-tip-box {
  display: flex;
  align-items: center;
  height: 70px;
  padding-left: 10px;
  border-bottom: 1px solid #CCCCCC;
}

.right-box-tip {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
}

.right-item {
  display: flex;
  align-items: center;
  height: 40px;
  font-size: 14px;
  color: #12618A;
  border-bottom: 1px solid #F7F7F7;
  cursor: pointer;
}

// 技能 / 工具 / 记忆：一行三等分快捷项
.right-quick-row {
  display: flex;
  gap: 8px;
  padding: 19px 10px;
  border-bottom: 1px solid #F0F2F5;
}

.right-quick-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  border-radius: 4px;
  background: #F5F7FA;
  font-size: 13px;
  color: #12618A;
  cursor: pointer;

  &:hover {
    background: #EAF3FF;
  }

  &.active {
    background: #00adff;
    color: #fff;
    font-weight: bold;
  }
}

.right-item-select {
  width: 8px;
  height: 100%;
  background-color: #00adff;
}

.right-item-unselect {
  width: 8px;
  height: 100%;
  background-color: transparent;
}

.right-item-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0 15px 0 20px;
  // 底部功能区图标（模型配置齿轮 / 员工商店）
  .right-item-icon {
    margin-right: 6px;
    font-size: 14px;
    color: #909399;
  }
}

// 对话 Tab 下：右侧功能列下方的数字员工列表
.right-agent-box {
  padding: 10px 10px 16px;
  border-top: 1px solid #CCCCCC;
}

.right-agent-head {
  margin: 4px 2px 8px;
  font-size: 13px;
  font-weight: bold;
  color: #303133;
}

.right-agent-list {
  max-height: 42vh;
  overflow-y: auto;
}

.right-agent-item {
  display: flex;
  align-items: center;
  height: 34px;
  padding: 0 10px;
  border-radius: 4px;
  font-size: 13px;
  color: #12618A;
  cursor: pointer;

  &:hover {
    background: #f5f7fa;
  }

  &.active {
    background: #e6f2ff;
    color: #0072c6;
    font-weight: bold;
    box-shadow: inset 3px 0 0 #00adff;

    .right-agent-icon {
      background: #00adff;
      color: #fff;
    }
  }

  .right-agent-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    margin-right: 8px;
    border-radius: 50%;
    background: #ecf5ff;
    color: #7fa8d8;
    font-size: 13px;
    flex: 0 0 auto;
  }

  .right-agent-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.right-agent-empty {
  padding: 6px 2px;
  font-size: 12px;
  color: #909399;
}
</style>
